export const getCurrentDate = () => `/Date(${Date.now()})/`;
